import { render, staticRenderFns } from "./DictionariesGroup.vue?vue&type=template&id=1b7f14d7&scoped=true&"
import script from "./DictionariesGroup.vue?vue&type=script&lang=js&"
export * from "./DictionariesGroup.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesGroup.vue?vue&type=style&index=0&id=1b7f14d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7f14d7",
  null
  
)

export default component.exports